import {Method, N3NetworkType} from '@/libs/wallet-connect-sdk-core/types'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'

export class N3WalletConnectConfig {
  static readonly methods: Method[] = ['invokeFunction']

  static networkFor(network: TWalletNetwork): N3NetworkType {
    return network === 'testnet' ? 'neo3:testnet' : 'neo3:mainnet'
  }
}
